import { render } from "./PaymentsPage.vue?vue&type=template&id=25d23da4&scoped=true"
import script from "./PaymentsPage.vue?vue&type=script&lang=js"
export * from "./PaymentsPage.vue?vue&type=script&lang=js"

import "./PaymentsPage.vue?vue&type=style&index=0&id=25d23da4&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/fep.theismailiusa.org/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d23da4"]])

export default __exports__